import React from 'react';
import { X, ShoppingCart, Package, Star } from 'lucide-react';
import { useCart } from '../context/CartContext';
import './ProductModal.css';

const ProductModal = ({ product, isOpen, onClose }) => {
  const { addToCart } = useCart();

  if (!isOpen || !product) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();
    // Vérifier si le produit est en rupture de stock
    if (product.stock === 0) {
      return;
    }
    addToCart(product, 1);
    // Fermer la modal après l'ajout au panier
    onClose();
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };

  return (
    <div className="product-modal-overlay" onClick={handleOverlayClick}>
      <div className="product-modal" onClick={(e) => e.stopPropagation()}>
        <div className="product-modal-content">
          <button className="product-modal-close" onClick={onClose} aria-label="Fermer">
            <X size={20} />
          </button>
          <div className="product-modal-image-section">
            <img 
              src={product.image} 
              alt={`${product.name} - ${product.category} bio`} 
              className="product-modal-image"
              loading="lazy"
            />
            {product.featured && (
              <div className="product-modal-featured-badge">
                <Star size={16} />
                <span>Coup de cœur</span>
              </div>
            )}
          </div>

          <div className="product-modal-info-section">
            <div className="product-modal-header">
              <div className="product-modal-category">
                <Package size={16} />
                <span>{product.category}</span>
              </div>
              <h2 className="product-modal-name">{product.name}</h2>
            </div>

            <div className="product-modal-description">
              <p>{product.description || 'Aucune description disponible pour ce produit.'}</p>
            </div>

            <div className="product-modal-details">
              <div className="product-modal-detail-item">
                <span className="detail-label">Prix :</span>
                <span className="detail-value price">{formatPrice(product.price)} / {product.unit}</span>
              </div>
              
              <div className="product-modal-detail-item">
                <span className="detail-label">Stock :</span>
                <span className={`detail-value stock ${product.stock < 5 ? 'low' : product.stock === 0 ? 'out' : ''}`}>
                  {product.stock > 0 ? `${product.stock} disponible${product.stock > 1 ? 's' : ''}` : 'Rupture de stock'}
                </span>
              </div>

              {product.stock < 5 && product.stock > 0 && (
                <div className="product-modal-warning">
                  ⚠️ Stock faible
                </div>
              )}
            </div>

            <div className="product-modal-actions">
              <button
                className="product-modal-add-btn"
                onClick={handleAddToCart}
                disabled={product.stock === 0}
              >
                <ShoppingCart size={20} />
                <span>{product.stock === 0 ? 'Rupture de stock' : 'Ajouter au panier'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
